
const digest = '8e3c8102c40ba725f272b7c94eae22b832a1276f2a216ca235d5f9b84b1e56cb';
const classes = {"wrapper":"_wrapper_cowqz_1","radioWrapper":"_radioWrapper_cowqz_7","radio":"_radio_cowqz_7","active":"_active_cowqz_26","title":"_title_cowqz_31","errorMessage":"_errorMessage_cowqz_36","disabled":"_disabled_cowqz_42","inLine":"_inLine_cowqz_53"};
const css = `._wrapper_cowqz_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
}

._radioWrapper_cowqz_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12.5px;
  cursor: pointer;
  margin-right: 15px;
}

._radio_cowqz_7 {
  width: 25px;
  height: 25px;
  background: url("/dist/icons/react/radio-default.svg") no-repeat center;
  background-size: contain;
  margin-right: 7.5px;
  cursor: pointer;
  flex: none;
}

._active_cowqz_26 {
  background: url("/dist/icons/react/radio-selected.svg") no-repeat center;
  background-size: contain;
}

._title_cowqz_31 {
  font-size: 14px;
  font-weight: 500;
}

._errorMessage_cowqz_36 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}

._disabled_cowqz_42 {
  cursor: not-allowed;
}
._disabled_cowqz_42 ._radio_cowqz_7 {
  opacity: 0.8;
  cursor: not-allowed;
}
._disabled_cowqz_42 ._title_cowqz_31 {
  color: #939393;
}

._inLine_cowqz_53 {
  display: flex !important;
  flex-direction: row !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  